<template>
  <svg v-bind="$attrs" :viewBox="viewbox" :class="{[classWhenInView]: inView}">
    <circle
      :cx="r"
      :cy="r"
      :r="r - 1"
      stroke="currentcolor"
      fill="none"
      :style="style"
      class="fix-transiton-stroke-dashoffset duration-1000 delay-inherited origin-center -rotate-[135deg]"
    ></circle>
  </svg>
</template>

<script>
import inViewMixin from '../../mixins/in-view'

export default {
  name: 'CircleStrokeAnimation',
  mixins: [inViewMixin],
  props: {
    r: Number,
    classWhenInView: String,
  },
  computed: {
    viewbox() {
      return `0 0 ${2 * this.r} ${2 * this.r}`
    },
    style() {
      const style = {
        strokeDasharray: 2 * Math.PI * (this.r - 1),
      }
      if (!this.inView) {
        style.strokeDashoffset = style.strokeDasharray
      }
      return style
    },
  },
}
</script>